import { useSyncExternalStore } from 'react';

import { i18n } from '../../i18n/index.js';

/** Re-render legacy singleton consumers when the active locale changes. */
export function useI18nSubscription(): void {
  useSyncExternalStore(
    (listener) => i18n.subscribe(listener),
    () => i18n.locale,
    () => i18n.locale,
  );
}
